import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';
import Skill from './Skill';
import './style.scss';

export default function Skills({ skills, biData }) {
    if (!skills.length) { return null; }

    const seller_card_about_me_skills_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_skills_impression',
        data: skills
    });

    return (
        <WithImpressions className="skills" value={seller_card_about_me_skills_impression}>
            <h3><I18n k="user_page_perseus.seller_profile.skills"/></h3>
            <ul>
                {skills.map((skill, idx) =>
                    <Skill skill={skill} key={idx}/>)}
            </ul>
        </WithImpressions>
    );
}

Skills.propTypes = {
    skills: PropTypes.array,
    biData: PropTypes.object
};

Skills.defaultProps = {
    skills: [],
    biData: {}
};
